import React from "react";
import { Segment, Button, Header, Icon } from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";

const Exporter = props => {
  let mainHeading =
    typeof props.mainHeading !== "undefined"
      ? props.mainHeading
      : "Export Data";

  if (props.userRole === "admin") {
    return (
      <Segment.Group style={{ marginTop: "0" }}>
        <Segment className="filter-section-expanded">
          <Header>
            {mainHeading}
            <div className="float-right filter-meta">
              <small className="gray-text" onClick={() => props.onSelectNone()}>
                Clear All Filters
              </small>
            </div>
          </Header>
        </Segment>
        <Segment className="filter-section-expanded">
          <Header as="h4">Generate CSV File</Header>
          <p>
            Select any desired filters below, then click on the button to
            generate and download a CSV file that can be opened in Microsoft
            Excel (or any other spreadsheet app). Note that this may take a
            minute or two for large datasets.
          </p>

          <Button primary className="button-primary" onClick={props.doExport}>
            <Icon name="download" /> Download CSV
          </Button>
        </Segment>
      </Segment.Group>
    );
  } else {
    return (
      <div>
        <h3>[Export Access Denied]</h3>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(Exporter);



// WEBPACK FOOTER //
// ./src/components/misc/Exporter.js